const socialMedia = [
  {
    name: "LinkedIn",
    url: "https://www.linkedin.com/in/daniel-felipe-trujillo-50224ab9/",
  },
  {
    name: "Github",
    url: "https://github.com/truxxu",
  },
];

export default socialMedia;
